import { render } from "./PhoneIcon.component.vue?vue&type=template&id=7786c6ae"
import script from "./PhoneIcon.component.vue?vue&type=script&lang=js"
export * from "./PhoneIcon.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/legacy/searchFind/cardType/PhoneIcon.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7786c6ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7786c6ae', __exports__)) {
    console.log('reload')
    api.reload('7786c6ae', __exports__)
  }
  
  module.hot.accept("./PhoneIcon.component.vue?vue&type=template&id=7786c6ae", () => {
    console.log('re-render')
    api.rerender('7786c6ae', render)
  })

}


export default __exports__